import React, { Component } from 'react';
import { translate } from 'react-i18next';
import moment from 'moment-timezone';
import { Link } from 'react-router-dom';


class CardHistory extends Component {
    render() {
        const rooms = this.props.rooms;
        const { t } = this.props;
        const memberId = this.props.usert ? true : false

        return (
            <div className="list-card-resvations" >
                <div className="list-card-panel-seccion">
                    <div className="content-card-panel-seccion">
                        <div className="row list list2">
                            {rooms.map((room, index) =>
                            (
                                <div className="col-lg-6 col-md-6 col-sm-12 col-12 card-panel-rooms" key={index}>
                                    <div className="card-panel panel panel-default card">
                                        <div className="panel-heading" style={{ backgroundImage: "url('" + room.picture + "')" }}>
                                        </div>
                                        <div className="card-panel-body">
                                            <div className="panel-body-title">
                                                <h4 className="ioscentro">{room.name.toUpperCase()}</h4>
                                            </div>
                                            <div className="panel-body-description">
                                                {room.title ? (
                                                    <div className="panel-description-text">
                                                        {room.title.slice(0, 150)}{room.title.length > 150 ? '...' : null}
                                                    </div>
                                                ) : (
                                                    <div className="panel-description-text">
                                                        Reservacopm de Sala {room.name.toUpperCase()}
                                                    </div>
                                                )}

                                                <div className="panel-description-information">
                                                    <div className="contenedor-flexbox">
                                                        <div className="contenedor">
                                                            <i className="fa fa-users" aria-hidden="true">
                                                            </i>
                                                            Capacidad para {room.capacity} personas.
                                                        </div>
                                                    </div>
                                                    <div className="contenedor-flexbox">
                                                        <div className="contenedor">
                                                            <i className="fa fa-calendar" aria-hidden="true"></i>
                                                            {moment(room.start_date, 'YYYY-MM-DD HH:mm:ss').format('ll')}
                                                        </div>
                                                    </div>
                                                    <div className="contenedor-flexbox">
                                                        <div className="contenedor">
                                                            <i className="fa fa-clock-o" aria-hidden="true"></i>
                                                            {moment(room.start_date, 'YYYY-MM-DD HH:mm:ss').format('HH:mm')} - {moment(room.end_date, 'YYYY-MM-DD HH:mm:ss').format('HH:mm')}
                                                        </div>
                                                    </div>
                                                    <div className="panel-body-bottom">
                                                        <div className="form-group">
                                                            <Link to={"/history/" + room.id}>
                                                                <button
                                                                    className="btn btn-block btn-primary btn-singup btn_create"
                                                                    type="button">
                                                                    {t('dashboard.history.btn_info')}
                                                                </button>
                                                            </Link>
                                                        </div>
                                                        {room.update && memberId  && !room.cancel_button ? (
                                                            <div className="panel-body-bottom">
                                                                <div className="form-group">
                                                                    <button
                                                                        className="btn btn-block btn-secondary btn_create"
                                                                        onClick={() => this.props.updateReservation(room)}
                                                                        type="button">
                                                                        {t('dashboard.history.Extend_reservation')}
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        ) : null}
                                                        {room.cancel_button && memberId ? (
                                                            <div className="panel-body-bottom">
                                                                <div className="form-group">
                                                                    <button
                                                                        className="btn btn-block btn-secondary btn_create"
                                                                        onClick={() => this.props.cancelarReservation(room)}
                                                                        type="button">
                                                                        {t('dashboard.history.cancel_reservation')}
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default translate('common')(CardHistory);


// WEBPACK FOOTER //
// ./src/dashboard/history/CardHistory.js